import request from "root/js/request";

export const getParsersCollectionsKeywords = async ({ limit, offset, ...rest }) => {
  const response = await request({
    url: `/parsers/collections/keywords/`,
    method: "get",
    params: {
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
